export const levelOptions = {
  GLB: {
    contextualDatasetLevelId: 'GLB',
    geoLevelId: 'GLB',
    id: 'GLB',
    options: null,
  },
  REG: {
    contextualDatasetLevelId: 'REG',
    geoLevelId: 'REG',
    id: 'REG',
    options: [
      {
        id: 'GLSE',
      },
      {
        id: 'COTS',
      },
      {
        id: 'RAME',
      },
      {
        id: 'RSAO',
      },
      {
        id: 'REHAGL',
      },
      {
        id: '0M',
      },
      {
        id: 'HQ',
      },
      {
        id: 'RMENA',
      },
      {
        id: 'RASO',
      },
      {
        id: 'RWCA',
      },
      {
        id: 'REUR',
      },
    ],
  },
  OPR: {
    contextualDatasetLevelId: 'OPR',
    geoLevelId: 'OPR',
    id: 'OPR',
    options: [
      {
        id: 'Global Programmes',
      },
      {
        id: 'EDM ABC',
      },
      {
        id: 'ITA MC ABC',
      },
      {
        id: 'BIH ABC',
      },
      {
        id: 'DJI ABC',
      },
      {
        id: 'PER ABC',
      },
      {
        id: 'b7ae7d54-4ac1-47a7-94aa-3b1adc3c711c',
      },
      {
        id: 'OOR ABC',
      },
      {
        id: '7T3',
      },
      {
        id: 'IND ABC',
      },
      {
        id: 'POL ABC',
      },
      {
        id: '7SL',
      },
      {
        id: 'MLI ABC',
      },
      {
        id: 'COL ABC',
      },
      {
        id: 'LBR ABC',
      },
      {
        id: 'BGD ABC',
      },
      {
        id: 'OMB ABC',
      },
      {
        id: 'XEU ABC',
      },
      {
        id: 'INNV ABC',
      },
      {
        id: 'KOS ABC',
      },
      {
        id: 'CAF ABC',
      },
      {
        id: 'BEL MC ABC',
      },
      {
        id: 'NYO ABC',
      },
      {
        id: 'ECU ABC',
      },
      {
        id: 'BGR ABC',
      },
      {
        id: 'XSAO ABC',
      },
      {
        id: 'BRA ABC',
      },
      {
        id: 'OOE ABC',
      },
      {
        id: 'MDA ABC',
      },
      {
        id: 'MENARB ABC',
      },
      {
        id: 'MWI ABC',
      },
      {
        id: 'EURRB ABC',
      },
      {
        id: 'CAN ABC',
      },
      {
        id: 'AMERB ABC',
      },
      {
        id: 'SWE MC ABC',
      },
      {
        id: 'ZMB ABC',
      },
      {
        id: 'COG ABC',
      },
      {
        id: 'STCO ABC',
      },
      {
        id: '7SV',
      },
      {
        id: 'NPL ABC',
      },
      {
        id: 'XAS ABC',
      },
      {
        id: 'MLT ABC',
      },
      {
        id: '7UK',
      },
      {
        id: 'ETHICS ABC',
      },
      {
        id: 'PAK ABC',
      },
      {
        id: 'DEU ABC',
      },
      {
        id: 'CRI ABC',
      },
      {
        id: 'COTS',
      },
      {
        id: 'DHR ABC',
      },
      {
        id: 'GEO ABC',
      },
      {
        id: 'LAS ABC',
      },
      {
        id: 'ARM ABC',
      },
      {
        id: 'GOV ABC',
      },
      {
        id: 'UKR ABC',
      },
      {
        id: 'FRA ABC',
      },
      {
        id: 'GDS ABC',
      },
      {
        id: 'LBN ABC',
      },
      {
        id: 'EGY ABC',
      },
      {
        id: 'EVAL ABC',
      },
      {
        id: 'GRC ABC',
      },
      {
        id: 'Headquarters',
      },
      {
        id: 'BFA ABC',
      },
      {
        id: 'LKA ABC',
      },
      {
        id: 'MMR ABC',
      },
      {
        id: 'HND ABC',
      },
      {
        id: 'DRS ABC',
      },
      {
        id: 'OOA ABC',
      },
      {
        id: 'MAR ABC',
      },
      {
        id: 'HUN MC ABC',
      },
      {
        id: 'MKD ABC',
      },
      {
        id: 'LORB ABC',
      },
      {
        id: 'AZE ABC',
      },
      {
        id: 'SYR ABC',
      },
      {
        id: 'ESP ABC',
      },
      {
        id: 'GBR ABC',
      },
      {
        id: 'MYS ABC',
      },
      {
        id: 'INVP ABC',
      },
      {
        id: 'PHL ABC',
      },
      {
        id: 'SAORB ABC',
      },
      {
        id: 'XWCA ABC',
      },
      {
        id: 'ALB ABC',
      },
      {
        id: 'PSP ABC',
      },
      {
        id: 'TUR ABC',
      },
      {
        id: 'IRQ ABC',
      },
      {
        id: 'TCS ABC',
      },
      {
        id: 'IDN ABC',
      },
      {
        id: 'XEHGL ABC',
      },
      {
        id: 'SSD ABC',
      },
      {
        id: 'NER ABC',
      },
      {
        id: 'DZA ABC',
      },
      {
        id: 'COD ABC',
      },
      {
        id: 'ERM ABC',
      },
      {
        id: 'XAM ABC',
      },
      {
        id: 'JPN ABC',
      },
      {
        id: 'DER ABC',
      },
      {
        id: 'KOR ABC',
      },
      {
        id: 'MRT ABC',
      },
      {
        id: 'IGO ABC',
      },
      {
        id: 'YEM ABC',
      },
      {
        id: 'MEX ABC',
      },
      {
        id: 'HRV ABC',
      },
      {
        id: 'SLV ABC',
      },
      {
        id: 'CIV ABC',
      },
      {
        id: 'SOM ABC',
      },
      {
        id: 'ZWE ABC',
      },
      {
        id: 'DSPR ABC',
      },
      {
        id: 'ERI ABC',
      },
      {
        id: 'BLR ABC',
      },
      {
        id: 'LBY ABC',
      },
      {
        id: 'SAU MC ABC',
      },
      {
        id: 'XME ABC',
      },
      {
        id: 'SDN ABC',
      },
      {
        id: 'CGSC ABC',
      },
      {
        id: 'DFAM ABC',
      },
      {
        id: 'DIP ABC',
      },
      {
        id: 'DESS ABC',
      },
      {
        id: '7SW',
      },
      {
        id: 'JOR ABC',
      },
      {
        id: 'BDI ABC',
      },
      {
        id: 'TZA ABC',
      },
      {
        id: 'GTM ABC',
      },
      {
        id: 'UGA ABC',
      },
      {
        id: 'DIST ABC',
      },
      {
        id: '7UI',
      },
      {
        id: '7S2',
      },
      {
        id: 'OOM ABC',
      },
      {
        id: 'CYP ABC',
      },
      {
        id: 'WCARB ABC',
      },
      {
        id: 'ASORB ABC',
      },
      {
        id: 'MOZ ABC',
      },
      {
        id: 'CHN ABC',
      },
      {
        id: 'GSC ABC',
      },
      {
        id: 'DDS ABC',
      },
      {
        id: 'AGO ABC',
      },
      {
        id: 'ROU ABC',
      },
      {
        id: 'RWA ABC',
      },
      {
        id: 'RUS ABC',
      },
      {
        id: 'ESH ABC',
      },
      {
        id: 'EHGLRB ABC',
      },
      {
        id: 'TUN ABC',
      },
      {
        id: 'AUS MC ABC',
      },
      {
        id: 'ISR ABC',
      },
      {
        id: 'MNE ABC',
      },
      {
        id: 'GHA ABC',
      },
      {
        id: 'AFG ABC',
      },
      {
        id: 'CIV MC ABC',
      },
      {
        id: 'NGA ABC',
      },
      {
        id: 'TCD ABC',
      },
      {
        id: 'VEN ABC',
      },
      {
        id: 'IRN ABC',
      },
      {
        id: 'ETH ABC',
      },
      {
        id: 'SRB ABC',
      },
      {
        id: 'TJK ABC',
      },
      {
        id: 'KEN ABC',
      },
    ],
  },
};
